var F={50:"#F4F7F7",100:"#E9EFF0",200:"#D2E0E0",300:"#8FB2B2",400:"#417B7C",500:"#1F6465",600:"#1A5556",700:"#164647",800:"#103233"};export{F as default};
